import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-green-dark text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm">
              &copy; {new Date().getFullYear()} Alessandra Filzoli. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-4">
            <Link to="/webinar-leggeri-e-sfiammati" className="text-white hover:text-accent transition-colors duration-300">
              Webinar Leggeri e Sfiammati 
            </Link>
            <Link to="/newsletter" className="text-white hover:text-accent transition-colors duration-300">
              Newsletter
            </Link>
            <Link to="/contact" className="text-white hover:text-accent transition-colors duration-300">
              Contattaci
            </Link>
            <Link to="/privacy" className="text-white hover:text-accent transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white hover:text-accent transition-colors duration-300">
              Termini e Condizioni
            </Link>


          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;